import { createSelector } from '@ngrx/store';
import { Ticket } from '@zero/shared/util-models';
import { ticketsFeature } from './ticket.reducer';

export const selectTicketTickets = createSelector(ticketsFeature.selectTickets, (tickets) =>
  tickets?.map((ticket) => Object.assign(new Ticket(), ticket)),
);
export const selectTicketById = (id: number) =>
  createSelector(selectTicketTickets, (tickets) => tickets.find((ticket) => ticket.id === id));
